import React from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import { withStyles} from '@material-ui/core/styles'
import {
  Grid, Table, TableHeaderRow
} from '@devexpress/dx-react-grid-material-ui'

const styles = {
  customCell: {
    whiteSpace: "normal",
    wordWrap: "break-word"
  }
}

const CustomTableCellBase = ({ classes, ...restProps }) => (
  <Table.Cell className={classes.customCell} {...restProps} />
)

const CustomTableBase = ({ style, ...restProps }) => (
  <Table.Table
    style={{
      ...style,
      minWidth: 0
    }}
    {...restProps}
  />
)

const CustomTableCell = withStyles(styles)(CustomTableCellBase);
const CustomTable = withStyles(styles)(CustomTableBase);

class PrivacyTable extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: "actionColumn", title: "Privacy Mask Settings" },
        { name: "descriptionColumn", title: "Description" }
      ],
      rows: [
        { actionColumn: 'Areas', descriptionColumn: 'Click the radio button behind the area (1-4) that you want to edit. Move your mouse pointer over the image hold the left mouse button to draw your privacy mask. To draw a second mask, activate area 2 and repeat the step.' },
        { actionColumn: 'Active', descriptionColumn: 'Check the Active box to activate the corresponding Area. The area will be masked inside the live video, video recordings as well as in snapshots.' },
        { actionColumn: 'Full Area', descriptionColumn: 'Maximize the selected area to the full size of the frame.' },
        { actionColumn: 'Reset', descriptionColumn: 'Return all areas to their default positions.' },
      ]
    };
  }
  render() {
    const { rows, columns } = this.state;

    return (
      <Paper style={{display: 'inline-block', maxWidth: '915px'}}>
        <Grid rows={rows} columns={columns}>
          <Table tableComponent={CustomTable} cellComponent={CustomTableCell} />
          <TableHeaderRow />
        </Grid>
      </Paper>
    );
  }
}

PrivacyTable.propTypes = {
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(PrivacyTable)